import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { context } from "../../context/context";
import { FaArrowRight } from "react-icons/fa6";
import { getApi } from "../../services/api/globalApi";
import {
  PiSignOutBold,
  PiMoneyFill,
  PiChartLineFill,
  PiEnvelope,
  PiShieldCheckFill,
  PiInfoBold,
} from "react-icons/pi";
import Cookies from "js-cookie";

const SideBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { show, setShow, user } = useContext(context);

  const logOut = async () => {
    try {
      const path = "admin/auth/logout";
      await getApi({ path });
      Cookies.remove("liResponse");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const [sideBarToggle, setSideBarToggle] = useState({
    subMenu1: false,
    subMenu2: false,
    subMenu3: false,
    subMenu4: false,
    subMenu5: false,
    subMenu6: false,
    subMenu7: false,
    subMenu8: false,
  });

  const [unansweredCount, setUnansweredCount] = useState(0);

  const getUnAnswered = async () => {
    const path = "admin/tickets/unanswered";
    try {
      const response = await getApi({ path });
      setUnansweredCount(response?.data?.data?.count);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUnAnswered();
    setInterval(() => {
      getUnAnswered();
    }, 120000);
  }, []);

  return (
    <>
      {show && (
        <div className="fixed w-screen h-screen z-[1490] bg-black/30 backdrop-blur-sm lg:hidden"></div>
      )}
      <aside
        className={`fixed -right-[300px] top-0 z-[1500] flex h-screen overflow-y-scroll w-[300px] lg:w-3/12 flex-col overflow-y-hidden  bg-white/50 backdrop-blur-sm shadow-[0px_0px_25px_-5px_rgba(0,0,0,0.2)] dark:bg-[#060d26]/50 backdrop-blue-sm transition-all ease-linear lg:right-0 ${show && "!right-0"
          }`}
      >
        <div className="flex items-center justify-between gap-2 px-6 py-4">
          <img
            className="w-10/12 rounded-lg"
            src={require("./../../assets/images/logoo.png")}
            alt="Logo"
          />
          <FaArrowRight
            onClick={() => setShow(!show)}
            size={38}
            className="text-red-700 lg:hidden p-1 bg-white dark:bg-gray-800 rounded-md transition-all cursor-pointer hover:scale-110"
          />
        </div>
        <div className="flex w-full  max-w-xs p-4">
          <ul className="flex flex-col items-start w-full">
            <li className="my-px lg:w-full">
              <NavLink
                onClick={() => setShow(!show)}
                to="/"
                className={`${["/"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="flex items-center justify-center text-lg">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                  </svg>
                </span>
                <span className="mx-3">داشبورد</span>
                {/* <span className="flex items-center justify-center text-sm text-gray-500 dark:text-white font-semibold bg-gray-300 h-6 px-2 rounded-full ml-auto">3</span> */}
              </NavLink>
            </li>
            <li className="my-px lg:w-full">
              <span className="flex font-medium text-sm  text-gray-600 lg:text-gray-400 px-4 my-4 uppercase">
                ابزار ها
              </span>
            </li>

            <li
              className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu2 && "max-h-56"
                }`}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu2: !sideBarToggle.subMenu2,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <span className="flex items-center justify-center text-lg">
                  <svg
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                </span>
                <span className="mx-3">کاربران</span>
              </h3>

              <NavLink
                onClick={() => setShow(!show)}
                to="/user"
                className={`${["/user"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="mx-3">افزودن کاربر</span>
              </NavLink>

              <NavLink
                onClick={() => setShow(!show)}
                to="/user-list"
                className={`${["/user-list"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="mx-3">لیست کاربران</span>
              </NavLink>
            </li>
            {/* <li
              className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu4 && "max-h-56"
                }`}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu4: !sideBarToggle.subMenu4,
                  })
                }
                className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <PiMoneyFill size={28} />
                <span className="mx-3">وام</span>
              </h3>

              <NavLink
                onClick={() => setShow(!show)}
                to="/loan-list"
                className={`${["/loan-list"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="mx-3">لیست وام ها</span>
              </NavLink>
            </li> */}
            {/* <li
              className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu5 && "max-h-56"
                }`}
            >
              <h3
                onClick={() =>
                  setSideBarToggle({
                    ...sideBarToggle,
                    subMenu5: !sideBarToggle.subMenu5,
                  })
                }
                className='flex flex-row items-center relative cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
              >
                <PiEnvelope size={28} />
                <span className="mx-3">پیام</span>
                {unansweredCount ? (
                  <span className="absolute bottom-1 right-7 bg-blue-500 text-white w-5 h-5 flex items-center justify-center rounded-xl text-xs">
                    {unansweredCount}
                  </span>
                ) : null}
              </h3>
              <NavLink
                onClick={() => setShow(!show)}
                to="/ticket"
                className={`${["/ticket"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="mx-3">پیام جدید</span>
              </NavLink>

              <NavLink
                onClick={() => setShow(!show)}
                to="/ticket-list"
                className={`${["/ticket-list"].includes(location.pathname)
                  ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                  : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                  }`}
              >
                <span className="mx-3">لیست پیام ها</span>
              </NavLink>
            </li> */}

            {/* {user?.role == "admin" && ( */}
            <>
              <li
                className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu3 && "max-h-56"
                  }`}
              >
                <h3
                  onClick={() =>
                    setSideBarToggle({
                      ...sideBarToggle,
                      subMenu3: !sideBarToggle.subMenu3,
                    })
                  }
                  className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
                >
                  <span className="flex items-center justify-center text-lg">
                    <svg
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="h-6 w-6"
                    >
                      <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                    </svg>
                  </span>
                  <span className="mx-3">نمایندگان</span>
                </h3>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/agent"
                  className={`${["/agent"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">افزودن نماینده</span>
                </NavLink>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/agent-list"
                  className={`${["/agent-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">لیست نماینده ها</span>
                </NavLink>
              </li>
              <li
                className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu6 && "max-h-56"
                  }`}
              >
                <h3
                  onClick={() =>
                    setSideBarToggle({
                      ...sideBarToggle,
                      subMenu6: !sideBarToggle.subMenu6,
                    })
                  }
                  className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
                >
                  <PiChartLineFill size={28} />
                  <span className="mx-3">سود اقساط</span>
                </h3>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/profit-loans-formula"
                  className={`${["/profit-loans-formula"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">وامی</span>
                </NavLink>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/profit-cheque-formula"
                  className={`${["/profit-cheque-formula"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">چکی</span>
                </NavLink>
              </li>
              <li className="my-px lg:w-full">
                <NavLink
                  onClick={() => setShow(!show)}
                  to="/investment-formula"
                  className={`${["/investment-formula"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <PiChartLineFill size={28} />

                  <span className="mx-3">نرخ سرمایه گذاری</span>
                  {/* <span className="flex items-center justify-center text-sm text-gray-500 dark:text-white font-semibold bg-gray-300 h-6 px-2 rounded-full ml-auto">3</span> */}
                </NavLink>
              </li>
              <li className="my-px lg:w-full">
                <NavLink
                  onClick={() => setShow(!show)}
                  to="/loans-formula"
                  className={`${["/loans-formula"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <PiChartLineFill size={28} />

                  <span className="mx-3">خرید و فروش امتیاز</span>
                  {/* <span className="flex items-center justify-center text-sm text-gray-500 dark:text-white font-semibold bg-gray-300 h-6 px-2 rounded-full ml-auto">3</span> */}
                </NavLink>
              </li>
              <li
                className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu8 && "max-h-56"
                  }`}
              >
                <h3
                  onClick={() =>
                    setSideBarToggle({
                      ...sideBarToggle,
                      subMenu8: !sideBarToggle.subMenu8,
                    })
                  }
                  className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
                >
                  <span className="flex items-center justify-center text-lg">
                    <PiChartLineFill size={28} />
                  </span>
                  <span className="mx-3">نرخ امتیاز کاربران</span>
                </h3>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/user-loans-formula"
                  className={`${["/agent"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">افزودن نرخ</span>
                </NavLink>

                <NavLink
                  onClick={() => setShow(!show)}
                  to="/user-formula-list"
                  className={`${["/agent-list"].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                  <span className="mx-3">لیست نرخ ها</span>
                </NavLink>
              </li>

              {/* <li
                  className={`my-px space-y-1 lg:w-full max-h-12 transition-all duration-1000 overflow-hidden ${sideBarToggle.subMenu7 && "max-h-56"
                    }`}
                >
                  <h3
                    onClick={() =>
                      setSideBarToggle({
                        ...sideBarToggle,
                        subMenu7: !sideBarToggle.subMenu7,
                      })
                    }
                    className='flex flex-row items-center cursor-pointer h-12 px-4 rounded-lg text-gray-600 dark:text-white bg-gray-100" : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
                  >
                    <PiShieldCheckFill size={28} />
                    <span className="mx-3">دسترسی ها</span>
                  </h3>

                  <NavLink
                    onClick={() => setShow(!show)}
                    to="/permission"
                    className={`${["/permission"].includes(location.pathname)
                      ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                      : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                      }`}
                  >
                    <span className="mx-3">افزودن دسترسی</span>
                  </NavLink>

                  <NavLink
                    onClick={() => setShow(!show)}
                    to="/permission-list"
                    className={`${["/permission-list"].includes(location.pathname)
                      ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                      : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                      }`}
                  >
                    <span className="mx-3">لیست دسترسی ها</span>
                  </NavLink>
                </li> */}
              {/* <li className="my-px lg:w-full">
                  <NavLink
                    onClick={() => setShow(!show)}
                    to="/backup-list"
                    className={`${["/backup-list"].includes(location.pathname)
                      ? "flex flex-row items-center h-12 px-4 rounded-lg text-gray-600 bg-gray-200 dark:bg-gray-100"
                      : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
                      }`}
                  > <PiInfoBold size={28} />
                    <span className="mx-3">لیست بک آپ</span>
                  </NavLink>
                </li> */}
            </>
            {/* )} */}
            <li className="w-full my-px cursor-pointer" onClick={logOut}>
              <p className="flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700">
                <PiSignOutBold size={28} className="text-red-400" />
                <span className="mx-3">خروج</span>
              </p>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default SideBar;
